// apps/client/src/game/interactions/board.ts (M1-T17) — A at the plaza notice board opens the town news.
import { tuning } from '@whiskerton/content';
import type { Interaction } from '../interact';

export const interaction: Interaction = {
  id: 'board',
  find(ctx) {
    const map = ctx.store.map;
    if (ctx.space !== 'out' || !map) return null;
    const at = { x: map.sites.board.x + 0.5, y: map.sites.board.y + 0.5 };   // the standing tile directly south of the board
    if (Math.hypot(at.x - ctx.pos.x, at.y - ctx.pos.y) > tuning.town.interactRange) return null;
    return { id: 'board', at, verb: 'news.board', priority: 65 };
  },
  run(ctx) { ctx.store.openScreen('news', undefined); },
  fromTap(ctx, hit) {
    const map = ctx.store.map;
    if (ctx.space !== 'out' || !map || hit.object?.kind !== 'board') return null;
    return { id: 'board', at: { x: map.sites.board.x + 0.5, y: map.sites.board.y + 0.5 }, verb: 'news.board', priority: 65 };
  },
};
